module.exports = __webpack_public_path__ + "assets/img/Children-s Playground, Splash Play, Children-s Playroom.45ed5e62.jpg";